var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLlmPerplexity = function SvgLlmPerplexity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#20808D",
    strokeMiterlimit: 10,
    strokeWidth: 0.556,
    d: "m13.092.777-5.275 5.28h5.275zm0 0v1.445M7.805 0v20m.012-6.375 5.275 5.28v-7.57l-5.275-5.28-5.275 5.28m10.55 0-5.275-5.28m5.275 5.28v2.26h2.264v-7.54h-7.54m.001 0v7.57m0 0-5.275 5.28v-7.57m5.275-5.28-5.275 5.28v2.26H.277v-7.54zm0 .002L2.54.777v5.28z"
  })));
};
export default SvgLlmPerplexity;